import DataTable from "@/components/ui/DataTable";
import { LeaveBalanceDTO } from "@/models/leave-balances.model";
import React from "react";
import { columns } from "./columns";
import Card from "@/components/Card";

interface LeaveBalanceDataTableProps {
  leaveBalances: LeaveBalanceDTO[];
}
function LeaveBalanceDataTable({ leaveBalances }: LeaveBalanceDataTableProps) {
  return (
    <DataTable
      tableMinWidth="500px"
      columns={columns}
      data={leaveBalances}
      containerClassname="h-fit max-h-full overflow-y-auto relative"
    />
  );
}

export default LeaveBalanceDataTable;
